import { render, staticRenderFns } from "./QuickLaunchContact.vue?vue&type=template&id=fb5ff8c0"
import script from "./QuickLaunchContact.vue?vue&type=script&lang=js"
export * from "./QuickLaunchContact.vue?vue&type=script&lang=js"
import style0 from "./QuickLaunchContact.vue?vue&type=style&index=0&id=fb5ff8c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports